export * from '@src/components/templates/occl/buttons.tmpl.js';
export * from '@src/components/templates/occl/consent.tmpl.js';
export * from '@src/components/templates/occl/consentOverview.tmpl.js';
export * from '@src/components/templates/occl/features.tmpl.js';
export * from '@src/components/templates/occl/group.tmpl.js';
export * from '@src/components/templates/occl/history.tmpl.js';
export * from '@src/components/templates/occl/historyItem.tmpl.js';
export * from '@src/components/templates/occl/main.tmpl.js';
export * from '@src/components/templates/occl/pagination.tmpl.js';
export * from '@src/components/templates/occl/referenceItem.tmpl.js';
export * from '@src/components/templates/occl/references.tmpl.js';
export * from '@src/components/templates/occl/tefComsCustomerAttribute.tmpl.js';
export * from '@src/components/templates/occl/tooltip.tmpl.js';
export * from '@src/components/templates/occl/triStateButton.tmpl.js';
export * from '@src/components/templates/occl/triStateButtonsPart.tmpl.js';
